import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'lg'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'academic', 'finance', 'hr', 'government', 'library', 'hostel', 'transport', 'assets', 'portal', 'analytics', 'onboarding'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'usms-language',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;

export function setLanguage(lang: 'en' | 'lg') {
  return i18n.changeLanguage(lang);
}

export function getLanguage(): 'en' | 'lg' {
  return (i18n.language?.startsWith('lg') ? 'lg' : 'en') as 'en' | 'lg';
}
